import React from 'react';
import { styles } from "./styles";
import { Box, Button } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "authConfig";
import LargeLogo from "assets/icons/LargeLogo.svg";
import { getAllUsers, getAllRoles, getRole, getUserPermissions } from 'apis/user';
import { CommonUtil } from 'common/CommonUtil';

interface LoginProps {
}

const Login: React.FC<LoginProps> = () => {
  const { instance } = useMsal();


  const handleLogin = () => {
    instance
    .loginPopup(loginRequest).then(function (loginResponse) {
        console.log(loginResponse);
        localStorage.setItem("access_token",loginResponse.accessToken);
        localStorage.setItem("refresh_token",loginResponse.accessToken);
        // sessionStorage.setItem("idtkn",loginResponse.idToken);
        CommonUtil.sessionKey = loginResponse.idToken;
              if(loginResponse && loginResponse.account){
               // accountId = loginResponse.account.homeAccountId;

              }
            })
      .catch(e => {  console.log(e); // sessionStorage.setItem("appToken","Hi");});

    // instance.loginPopup(loginRequest).catch(e => {
    //   console.log(e);
    //  // sessionStorage.setItem("appToken","Hi");
    //   for (var x1 in sessionStorage){
    //     var obj = sessionStorage[x1];
    //     if(obj){
    //       try{
    //         var obj1 = JSON.parse(obj);
    //         if(obj1 && obj1.credentialType == "IdToken"){
    //           console.log(obj1.secret);
    //           sessionStorage.setItem("appToken",obj1.secret);
    //         }
    //       }catch(ex){}
    //     }
    //   }
    });
  }
  return (
    <Box sx={styles.container}>
      <Box sx={styles.loginBox}>
        <img src={LargeLogo} alt="" />
        <Button sx={styles.button} onClick={handleLogin}>Login</Button>
      </Box>
    </Box>

  )
}
/*export const refreshAccessToken = async () => {
    const account = getAccountInfo();
    try {
        const token = await msalInstance.acquireTokenSilent({
            scopes: loginRequest.scopes,
            account,
        });
        return token.accessToken;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            return msalInstance
                .acquireTokenPopup(loginRequest)
                .then((resp) => {
                    return resp.accessToken;
                })
                .catch((err) => {
                    return null;
                });
        } else {
            console.error(error);
        }
    }
};*/

export default Login;
